module.exports = `${require.publicPath}rbk.149b1434.png`;